import { FC, useCallback } from "react";
import { Stack } from "@mui/material";
import { useFlag } from "@unleash/proxy-client-react";
import { WidgetActions } from "./actions/WidgetActions";
import { WidgetEditButton } from "./actions/WidgetEditButton";
import { WidgetName } from "./source-and-name/widget-name/WidgetName";
import { WidgetTitleProps } from "../../../../utils/types/types";
import { useAppDispatch } from "@/store/hooks";
import { ExploreWithAIButtonV2 } from "@/storybook/explore-with-AI-button/ExploreWithAIButtonV2";

import { setExplainWithAiDataByWidgetIdFromDashboardThunk } from "@/store/dashboards/thunks/widgets/common/setExplainWithAiDataByWidgetIdFromDashboardThunk";
import { setExplainWithAiMode } from "@/store/explain-with-ai/explainWithAiSlice";
import { WidgetType } from "@/services/cloudchipr.api";
import { widgetsWhichHaveExplainWithAi } from "@/components/pages/dashboard/components/widgets/common/widget-header/utils/constants";

interface WidgetCardHeaderActionRowProps {
  hovered: boolean;
  widgetId: string;
  widgetType: WidgetType;
  widgetTitleProps: WidgetTitleProps | null;
}

export const WidgetCardHeaderActionRow: FC<WidgetCardHeaderActionRowProps> = ({
  widgetId,
  widgetTitleProps,
  widgetType,
  hovered,
}) => {
  const dispatch = useAppDispatch();
  const enableWidgetsExplainWithAIWithExplanation = useFlag(
    "EnableWidgetsExplainWithAIWithExplanation",
  );
  const explainWithAiButtonCLickHandler = useCallback(() => {
    dispatch(setExplainWithAiDataByWidgetIdFromDashboardThunk(widgetId));
    dispatch(setExplainWithAiMode("anomaly_detection_and_summary"));
  }, [dispatch, widgetId]);

  return (
    <Stack direction="row" justifyContent="space-between" pb={0.5}>
      {widgetTitleProps && (
        <WidgetName
          hovered={hovered}
          widgetId={widgetId}
          widgetType={widgetType}
          name={widgetTitleProps?.widgetName}
        />
      )}

      <Stack direction="row" spacing={1} alignItems="center" pr={1}>
        {hovered && (
          <WidgetEditButton widgetId={widgetId} widgetType={widgetType} />
        )}

        {enableWidgetsExplainWithAIWithExplanation &&
          widgetsWhichHaveExplainWithAi.has(widgetType) && (
            <ExploreWithAIButtonV2
              onClick={explainWithAiButtonCLickHandler}
              size="xsmall"
            />
          )}

        <WidgetActions
          widgetId={widgetId}
          widgetType={widgetType}
          widgetName={widgetTitleProps?.widgetName ?? ""}
        />
      </Stack>
    </Stack>
  );
};
